import React, { useEffect, useState } from "react";
import {
  Area,
  AreaChart,
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  Pie,
  PieChart,
  Tooltip,
  XAxis,
  YAxis
} from "recharts";

const DashBoard = () => {
  const [data, setData] = useState([]);
  useEffect(() => {
    fetch("chart.json")
      .then((res) => res.json())
      .then((data) => setData(data));
  }, []);
  return (
    <div>
      <section>
        <h1 className="text-blue-600 text-center text-2xl my-5 font-bold">
          Month Wish Sell
        </h1>
        <AreaChart
          width={1000}
          height={350}
          data={data}
          margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
        >
          <defs>
            <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8} />
              <stop offset="95%" stopColor="#82ca9d" stopOpacity={0} />
            </linearGradient>
          </defs>
          <XAxis dataKey="month" />
          <YAxis />
          <CartesianGrid strokeDasharray="3 3" />
          <Tooltip />
          <Area
            type="monotone"
            dataKey="sell"
            stroke="#82ca9d"
            fillOpacity={1}
            fill="url(#colorPv)"
          />
        </AreaChart>
      </section>
      <section>
        <h1 className="text-blue-600 text-center text-2xl my-5 font-bold">
          Investment VS Revenue
        </h1>
        <BarChart width={1000} height={350} data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="investment" fill="#8884d8" />
          <Bar dataKey="revenue" fill="#00ffff" />
        </BarChart>
      </section>
      <section>
        <h1 className="text-blue-600 text-center text-2xl my-5 font-bold">
          Investment VS Revenue
        </h1>
        <PieChart width={1000} height={450}>
          <Pie
            data={data}
            dataKey="sell"
            nameKey="month"
            cx="50%"
            cy="50%"
            outerRadius={80}
            fill="#8884d8"
          />
          <Pie
            data={data}
            dataKey="revenue"
            nameKey="month"
            cx="50%"
            cy="50%"
            innerRadius={100}
            outerRadius={130}
            fill="#82ca9d"
            label
          />
          <Tooltip />
        </PieChart>
      </section>
    </div>
  );
};

export default DashBoard;
